import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InterfaceElement } from "themes/types";

const themeSliceInitialState = {
  interfaceElements: ["header", "contacts", "footer"],
};

export const themeSlice = createSlice({
  name: "themeSlice",
  initialState: themeSliceInitialState,
  reducers: {
    setThemeElements(state, action: PayloadAction<InterfaceElement[]>) {
      state.interfaceElements = action.payload;
      return state;
    },
  },
});
export const interfaceElementsSelector = (store) =>
  store.themeSlice.interfaceElements;
export const { setThemeElements } = themeSlice.actions;
